export const regex = '^[1-9][0-9]{3}[\\s]?[a-zA-Z]{2}$';
export default regex;
